"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var CheckinManual = function CheckinManual(_a) {
  var fill = _a.fill,
      props = __rest(_a, ["fill"]);

  return react_1.default.createElement(Svg_1.default, __assign({}, props, {
    viewBox: "0 0 22.4 22.5"
  }), react_1.default.createElement("path", {
    fill: fill,
    d: "M6.7,0.1C6.5-0.1,6.2,0,6.1,0.2L2.7,5L0.8,3.1C0.6,3,0.3,3,0.1,3.1C0,3.3,0,3.6,0.1,3.8l2.3,2.3c0.1,0.1,0.2,0.1,0.3,0.1\n\t\tc0,0,0,0,0,0C2.9,6.2,3,6.1,3.1,6l3.8-5.3C7,0.5,7,0.2,6.7,0.1z"
  }), react_1.default.createElement("path", {
    fill: fill,
    d: "M20.1,3l2.2-2.2c0.2-0.2,0.2-0.5,0-0.6c-0.2-0.2-0.5-0.2-0.6,0l-2.2,2.2l-2.2-2.2c-0.2-0.2-0.5-0.2-0.6,0\n\t\tc-0.2,0.2-0.2,0.5,0,0.6L18.8,3l-2.2,2.2c-0.2,0.2-0.2,0.5,0,0.6c0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1l2.2-2.2l2.2,2.2\n\t\tc0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1c0.2-0.2,0.2-0.5,0-0.6L20.1,3z"
  }), react_1.default.createElement("path", {
    fill: fill,
    d: "M11.2,8.5c-2.2,0-4,1.8-4,4V22c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-9.5c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3V22\n\t\tc0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-9.5C15.2,10.3,13.4,8.5,11.2,8.5z"
  }), react_1.default.createElement("path", {
    fill: fill,
    d: "M11.2,5.5c-3.9,0-7,3.1-7,7c0,1.3,0.4,2.6,1.1,3.7c0.1,0.2,0.5,0.3,0.7,0.2c0.2-0.1,0.3-0.5,0.2-0.7\n\t\tc-0.6-1-0.9-2.1-0.9-3.2c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6c0,1.1-0.3,2.2-0.9,3.2c-0.1,0.2-0.1,0.5,0.2,0.7c0.1,0.1,0.2,0.1,0.3,0.1\n\t\tc0.2,0,0.3-0.1,0.4-0.2c0.7-1.1,1.1-2.4,1.1-3.7C18.2,8.6,15.1,5.5,11.2,5.5z"
  }), react_1.default.createElement("path", {
    fill: fill,
    d: "M11.2,10.5c-1.1,0-2,0.9-2,2V14c0,0.3,0.2,0.5,0.5,0.5h3c0.3,0,0.5-0.2,0.5-0.5v-1.5C13.2,11.4,12.3,10.5,11.2,10.5z\n\t\t M12.2,13.5h-2v-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1V13.5z"
  }));
};

exports.default = CheckinManual;
CheckinManual.displayName = 'CheckinManual';